var _defs, _path, _path2, _path3, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOpenBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.6994,
    height: 44.6948,
    viewBox: "0 0 44.6994 44.6948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#444;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.199,44.6948c-1.764,0-3.199-1.4348-3.199-3.1988V3.1988C0,1.4348,1.435,0,3.199,0s3.199,1.4348,3.199,3.1988v38.2972c0,1.764-1.435,3.1988-3.199,3.1988ZM3.199,1.7349c-.8072,0-1.4641.6564-1.4641,1.4638v38.2972c0,.8074.6569,1.4638,1.4641,1.4638s1.4641-.6564,1.4641-1.4638V3.1988c0-.8074-.6569-1.4638-1.4641-1.4638Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.5004,44.6909H3.2027C1.4389,44.6909.0039,43.2561.0039,41.4921s1.435-3.1988,3.1988-3.1988h38.2977c1.764,0,3.199,1.4348,3.199,3.1988s-1.435,3.1988-3.199,3.1988ZM3.2027,40.0283c-.8072,0-1.4638.6564-1.4638,1.4638s.6567,1.4638,1.4638,1.4638h38.2977c.8072,0,1.4641-.6564,1.4641-1.4638s-.6569-1.4638-1.4641-1.4638H3.2027Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.4981,22.6383c-.1234-2.5763-.8467-5.016-2.1493-7.2505-3.3849-5.808-9.9398-8.8518-16.6999-7.7481l-.3185-1.9576c7.5758-1.2325,14.9294,2.1842,18.7316,8.7066,1.4646,2.5133,2.2778,5.2571,2.4165,8.1548l-1.9804.0949Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "26.3129 .5254 16.0871 6.3656 26.2429 12.4993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenBlack);
export default __webpack_public_path__ + "static/media/icon_open_black.5485d1ea451a58af9aea05ea3394b0cd.svg";
export { ForwardRef as ReactComponent };